import { logEvent,setUserId,setUserProperties } from "firebase/analytics";
import { analytics,db } from "../firebase/firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { environment } from "../appconfig";







export const formatDate = (date) => {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${day} ${month} ${year}, ${hours}:${minutes}`;
};

export const DateSeparter = (value) => {
  const parsedDate = new Date(value);

  // Format date to DD MM YYYY
  const day = String(parsedDate.getDate()).padStart(2, "0"); // Day with leading zero
  const month = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Month with leading zero (getMonth() is 0-based)
  const year = parsedDate.getFullYear();
  const formattedDate = `${day}-${month}-${year}`;

  // Format time to 12-hour format with AM/PM
  let hours = parsedDate.getHours();
  const minutes = String(parsedDate.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // Convert to 12-hour format
  const formattedTime = `${hours}:${minutes} ${ampm}`;

  // Get the day of the week
  const dayOfWeek = parsedDate.toLocaleDateString("en-US", { weekday: "long" });
  const formattedDateMonthDDYYYY = parsedDate.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
  return {
    date: formattedDate,
    time: formattedTime,
    day: dayOfWeek,
    month: formattedDateMonthDDYYYY,
  };
};


// export const setAnalyticsUserName = (userName) => {
//   try {
//     console.log("setting user id");

//     setUserId(analytics, userName);

//     // ✅ OPTIONAL (for Explore reporting)
//     setUserProperties(analytics, {
//       custom_user_id: userName,
//     });

//   } catch (error) {
//     console.log(error, "Analytics error");
//   }
// };

export const logActivity = async (eventName, data = {}) => {
  try {

    if(environment !== "PRODUCTION") return;

    const dbData = {};

    dbData.branch = localStorage.getItem("branchName");
    dbData.timestamp= serverTimestamp()
    dbData.localTime = getISTTime()
    dbData.event = eventName
    dbData.payload = data
    await addDoc(collection(db, "storeManager"), {...dbData});
  } catch (err) {
    console.error("Analytics error:", err);
  }
}


const getISTTime = () => {
  return new Date().toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata"
  });
};



